import { render } from "./actorForm.vue?vue&type=template&id=68b89c44&scoped=true"
import script from "./actorForm.vue?vue&type=script&lang=js"
export * from "./actorForm.vue?vue&type=script&lang=js"

import "./actorForm.vue?vue&type=style&index=0&id=68b89c44&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b89c44"]])

export default __exports__